<div class="container">
  <h2 class="section-title">EPADS Training Manuals and Videos</h2>

  <section>
    <h3>Training Videos</h3>
    <a href="https://youtube.com/@PPRAEPADS" target="_blank">YOUTUBE CHANNEL</a>


    <!-- <ul>
      <li><a href="https:// youtube.com/@PPRAEPADS" target="_blank">How To Create Procurement Plan</a></li>
      <li><a href="https:// youtube.com/@PPRAEPADS" target="_blank">How To Create
          Petty</a></li>
      <li><a href="https:// youtube.com/@PPRAEPADS" target="_blank">How to Create RFQ</a>
      </li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA004.mp4" target="_blank">How To Create Committee</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA-005 How to Create Tender through File Uploading.mp4"
          target="_blank">How to Create Tender through File Uploading</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA-006 How to evaluate Bids by file uploading.mp4"
          target="_blank">How to evaluate Bids by file uploading</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA-007 How to Create Tender (E-Submission).mp4" target="_blank">How
          to Create Tender (E-Submission)</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA-008 How to Evaluate Tender (E-Submission).mp4"
          target="_blank">How to Evaluate Tender (E-Submission)</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA-009 How to Create PQ-EOI.mp4" target="_blank">How to Create
          PQ-EOI</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/PA-010 How to Evaluate Pre-Qualification-EOI.mp4"
          target="_blank">How to Evaluate Pre-Qualification-EOI</a></li>
    </ul>

    <h4>Suppliers/Bidders/Vendors:</h4>
    <ul>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 001 _ Supplier Registration.mp4" target="_blank">Supplier
          Registration</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 002 _ Supplier Profile creation till Approval from PPRA.mp4"
          target="_blank">Supplier Profile creation till Approval from PPRA</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 003 _ How to quote in Petty-RFQ.mp4" target="_blank">How to quote
          in Petty-RFQ</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 004 _ Bidding (File-Uploading for Supplier).mp4"
          target="_blank">Bidding (File-Uploading for Supplier)</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 005 _ Bidding (E-Submission) for Supplier.mp4"
          target="_blank">Bidding (E-Submission) for Supplier</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 006 _ How to Participate in PQ-EOI.mp4" target="_blank">How to
          Participate in PQ-EOI</a></li>
      <li><a href="https:// ppra.org.pk/epads/mm/SA 007 _ E-Catalogue For Supplier.mp4" target="_blank">E-Catalogue
          For Supplier</a></li>
    </ul>
  </section>
-->
    <section>
      <h3>Training Manuals</h3>
      <ul>
        <li><a href="https://old.ppra.org.pk/epads/mm/plan.pdf" target="_blank">Procurement Plan UTM e-PADS</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/supplier.pdf" target="_blank">Supplier Management for PPRA
            Admins
            UTM e-PADS</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/supplier2.pdf" target="_blank">Supplier Management for
            Suppliers</a>
        </li>
        <li><a href="https://old.ppra.org.pk/epads/mm/user.pdf" target="_blank">User Management UTM e-PADS</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/esubmission.pdf" target="_blank">Pre-qualification and
            e-Submission,
            e-Evaluation</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/e-Sourcing to e-Contracting.pdf" target="_blank">e-Sourcing to
            e-Contracting</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/Procurement Plan Module.pdf" target="_blank">Procurement Plan
            Module</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/Standard Bidding Documents & Bidding Process.pdf"
            target="_blank">Standard Bidding Documents & Bidding Process</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/Supplier Management for Suppliers for PPRA Punjab.pdf"
            target="_blank">Supplier Management for Suppliers for PPRA Punjab</a></li>
        <li><a
            href="https:// old.ppra.org.pk/epads/mm/Supplier Management for Suppliers Registration and  E-Submission.pdf"
            target="_blank">Supplier Management for Suppliers Registration and E-Submission</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/Supplier Management Module (Admin).pdf" target="_blank">Supplier
            Management Module (Admin)</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/Supplier Management Module.pdf" target="_blank">Supplier
            Management
            Module</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/Training Manual (Master Trainer).pdf" target="_blank">Training
            Manual (Master Trainer)</a></li>
        <li><a href="https://old.ppra.org.pk/epads/mm/User Management Module (For End Users).pdf" target="_blank">User
            Management Module (For End Users)</a></li>
      </ul>
    </section>